import { Component, inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { ServiceDoctorsCertificatesModalStore } from './service-doctors-certificates-modal.store';
import { TranslatePipe } from '@ngx-translate/core';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import { EmploymentEnum } from '@libs/types/src/user/enum/employment.enum';
import { fb } from '../../../../../modules/shared/shared.global-service';
import { Validators } from '@angular/forms';
import {
    UserUploadCertificateComponent,
} from '../../../../user-management/user-secrets/user-upload-certificate/user-upload-certificate.component';
import {
    UserUploadSecretComponent,
} from '../../../../user-management/user-secrets/user-upload-secret/user-upload-secret.component';
import { UserSecretTypeEnum } from '@libs/types/src/user/enum/user-secret-type.enum';
import {
    WorkDetailSelectUserComponent,
} from '../../../work/work-detail/work-detail-select-user/work-detail-select-user.component';

@Component({
    selector: 'app-service-doctors-secrets-modal',
    imports: [
        TranslatePipe,
        UserUploadCertificateComponent,
        UserUploadSecretComponent,
        WorkDetailSelectUserComponent,
    ],
    templateUrl: './service-doctors-certificates-modal.component.html',
    styleUrl: './service-doctors-certificates-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [ServiceDoctorsCertificatesModalStore],
})
export class ServiceDoctorsCertificatesModalComponent extends BaseDialogComponent {
    public readonly store = inject(ServiceDoctorsCertificatesModalStore);

    @ViewChild(UserUploadCertificateComponent)
    userUploadCertificateComponent!: UserUploadCertificateComponent;
    @ViewChild(UserUploadSecretComponent)
    userUploadSecretComponent!: UserUploadSecretComponent;

    protected readonly serviceId = this.dialogConfig.data.serviceId;
    protected readonly secretType = this.dialogConfig.data.secretType;

    public form = fb.group({
        userId: fb.control<string | null>(null, Validators.required),
    });

    override async save() {
        if (this.secretType === UserSecretTypeEnum.QUAL_CERT) {
            const res = await this.userUploadCertificateComponent.save();
            if (!res) {
                return;
            }
        } else if (this.secretType === UserSecretTypeEnum.SUKL_IDENTITY) {
            const res = await this.userUploadSecretComponent.save();
            if (!res) {
                return;
            }
        }
        contentGlobalSuccess.next('common.created');
        this.dialogRef.close(true);
    }

    protected readonly EmploymentEnum = EmploymentEnum;
    protected readonly UserSecretTypeEnum = UserSecretTypeEnum;
}
